import {lazy} from 'react';

import suspend from 'util/suspend';

import type {NoteEditorContainerProps} from './NoteEditor';

const NoteEditorContainer = lazy(
  () => import(/* webpackChunkName: "printer-friendly" */ './NoteEditorContainer')
);

export default suspend<NoteEditorContainerProps>(NoteEditorContainer);
